import React from "react";
import "./Footer.css";
import { FaFacebookF, FaYoutube, FaTwitter } from "react-icons/fa";

const Footer = () => {
  return (
    <footer>
      <div className="footer-container">
        <div className="footer-top">
          {/* Newsletter Section */}
          <div className="footer-newsletter">
            <h2>
              Sign up for the latest beauty news, product samples and coupons
            </h2>
            <p className="small-text">
              This site is intended for US consumers. By signing up, you
              understand and agree that your data will be collected and used
              subject to our US policy and terms of use.
            </p>
            <label htmlFor="email">
              Email Address <span className="HeadingBlack">*</span>
            </label>
            <input type="email" id="email" placeholder="Enter your email" />
            <button type="submit">SIGN UP</button>
            {/* <p className="required-info">*Required information</p> */}
            <div className="footer-icons">
              <FaFacebookF className="FYTIcons" />
              <FaYoutube className="FYTIcons" />
              <FaTwitter className="FYTIcons" />
            </div>
          </div>

          {/* Wrapper for Footer Sections in 2 columns on mobile */}
          <div className="footer-sections-wrapper">
            <div className="footer-section">
              <h4>MAKEUP</h4>
              <ul>
                <li>Face</li>
                <li>Eyes</li>
                <li>Lips</li>
                <li>Nails</li>
              </ul>
            </div>

            <div className="footer-section">
              <h4>SKINCARE</h4>
              <ul>
                <li>Moisturizers</li>
                <li>Cleansers</li>
                <li>Treatments</li>
                <li>Eye Care</li>
              </ul>
            </div>

            <div className="footer-section">
              <h4>COMPANY INFO</h4>
              <ul>
                <li>About Us</li>
                <li>Careers</li>
                <li>Press</li>
                <li>Contact Us</li>
              </ul>
            </div>

            <div className="footer-section">
              <h4>CUSTOMER CARE</h4>
              <ul>
                <li>Help Center</li>
                <li>Shipping</li>
                <li>Returns</li>
                <li>Track Order</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-links">
            <span>© 2025 NIAVH</span>
            <span>|</span>
            <span>Terms of Use</span>
            <span>|</span>
            <span>Privacy Policy</span>
            <span>|</span>
            <span>Ad Choices</span>
            {/* <span>|</span>
            <a onClick={scrollToTop} className="back-to-top">
              BACK TO TOP ˄
            </a> */}
          </div>
          <p className="disclaimer">
            This site is intended for US consumers. Cookies and related
            technology are used for advertising. To learn more, visit adchoices
            and our privacy policy.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
